import React from 'react'

import LocationMapImageV2 from 'components/customer-details/content/location/LocationMapImageV2'

type ExceptionMapImageProps = {
  dynamicWidth?: boolean
  id?: string
  latitude?: string | number | null
  longitude?: string | number | null
  // number (px) or a CSS length — the drawer's expanded map passes a viewport-relative height.
  height: number | string
  enableTypeToggle?: boolean
  gestureHandling?: string
}

const ExceptionMapImage: React.FC<ExceptionMapImageProps> = ({
  dynamicWidth = true,
  id,
  latitude,
  longitude,
  height,
  enableTypeToggle = false,
  gestureHandling = 'none',
}) => (
  <LocationMapImageV2
    showPlaceholder
    containerId={`exception-map-container-${id}`}
    dynamicWidth={dynamicWidth}
    enableTypeToggle={enableTypeToggle}
    gestureHandling={gestureHandling}
    height={height}
    latitude={latitude}
    longitude={longitude}
    showInvalidAlert={false}
    zoom={20}
  />
)

export default ExceptionMapImage
